import { clientFetch, url } from "@/components/shared/fetch-client/fetch_client";
import { FormikWrapper } from "@/components/shared/wrappers/formik-wrapper";
import BlockIcon from "@mui/icons-material/Block";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DialogWrapper from "../../../shared/dialog/dialog-wrapper";

export default function UserBlockDeblockDialog({ target_user, open, on_close, rows, set_rows }) {
	/* ---------------------------------- HOOKS --------------------------------- */
	const { t } = useTranslation();

	const [loading, setLoading] = useState(false);

	/* --------------------------- DELETE USER HANDLER -------------------------- */
	const blockDeblockUserHandler = async () => {
		setLoading(true);

		const { status } = await clientFetch(
			url`/api/back-office/user/${target_user.user_id}/blocked`,
		).put();
		setLoading(false);
		on_close();

		switch (status) {
			case 202:
				// Update set user blocked
				set_rows(
					rows.map((v) => (v.user_id === target_user.user_id ? { ...v, blocked: !v.blocked } : v)),
				);

				// Notify blocked when blocked
				if (target_user.blocked === true) {
					toast.success(t("back_office.customers.user_management.dialog.block.success_alert"));
					break;
				}

				toast.success(t("back_office.customers.user_management.dialog.deblock.success_alert"));

				break;

			default:
				toast.error(t("validation.errors.unknown"));
				break;
		}
	};

	return (
		<DialogWrapper
			title={
				target_user.blocked
					? t("back_office.customers.user_management.dialog.deblock.title")
					: t("back_office.customers.user_management.dialog.block.title")
			}
			open={open}
			on_close={on_close}
			close_button
		>
			<FormikWrapper initialValues={{}} onSubmit={blockDeblockUserHandler}>
				<Typography>
					{target_user.blocked ? (
						<Trans
							i18nKey="back_office.customers.user_management.dialog.deblock.description"
							values={{ username: target_user.username }}
						/>
					) : (
						<Trans
							i18nKey="back_office.customers.user_management.dialog.block.description"
							values={{ username: target_user.username }}
						/>
					)}
				</Typography>

				<Divider sx={{ my: 1 }} />

				<DialogActions sx={{ mb: 1, px: 0 }}>
					<Button variant="outlined" type="button" onClick={on_close} fullWidth>
						{t("buttons.cancel")}
					</Button>

					<LoadingButton
						variant="outlined"
						color="error"
						type="submit"
						loading={loading}
						startIcon={<BlockIcon />}
						disableElevation
						fullWidth
					>
						{target_user.blocked === true
							? t("back_office.customers.user_management.table.body.buttons.deblock")
							: t("back_office.customers.user_management.table.body.buttons.block")}
					</LoadingButton>
				</DialogActions>
			</FormikWrapper>
		</DialogWrapper>
	);
}
